<ion-app class="{{ accountRole }} {{ theme }}">
  <ion-menu side="start" menuId="mainMenu" contentId="main-content" class="main-menu-container" *ngIf="menuEnabled">
    <ion-content class="main-menu-wrapper" color="primary">
      <div class="menu-container">
        <div class="menu-header">
          <ion-avatar class="user-avatar" (click)="handleNavigate('profile')">
            <ion-img class="" src="assets/images/user_pic.svg" *ngIf="!viewAvatar"></ion-img>
            <ion-img class="" [src]="avatarUrl" *ngIf="viewAvatar"></ion-img>
          </ion-avatar>
          <h5>My Profile</h5>
        </div>
        <ion-list class="list-wrapper">
          <ion-item color="primary" (click)="handleNavigate('dashboard')" data-cy="dashboard-item">
            <ion-icon name="home-outline"></ion-icon>
            <ion-label>Dashboard</ion-label>
          </ion-item>
          <ion-item color="primary" (click)="handleNavigate('schedule')" data-cy="schedule-item">
            <ion-icon name="calendar-outline"></ion-icon>
            <ion-label>Schedule</ion-label>
          </ion-item>
          <ion-item color="primary" (click)="handleNavigate('report')" data-cy="report-item">
            <ion-icon name="document-text-outline"></ion-icon>
            <ion-label>Reports</ion-label>
          </ion-item>
          <ng-container *ldIf="'is-taskezy'">
            <ion-item color="primary" (click)="handleNavigate('accreditation')" data-cy="accreditation-item">
              <ion-icon name="medal-outline"></ion-icon>
              <ion-label>Accreditations</ion-label>
            </ion-item>
          </ng-container>
          <ion-item color="primary" (click)="handleNavigate('connections')" data-cy="connections-item">
            <ion-icon name="repeat-outline"></ion-icon>
            <ion-label>Connections</ion-label>
          </ion-item>
          <ion-item color="primary" (click)="handlePreference()" data-cy="preferences-item">
            <ion-icon name="settings-outline"></ion-icon>
            <ion-label>Preferences</ion-label>
          </ion-item>
          <ion-item color="primary" (click)="handleNavigate('help')" data-cy="help-item">
            <ion-icon name="help-buoy-outline"></ion-icon>
            <ion-label>Help</ion-label>
          </ion-item>
          <ion-item color="primary" (click)="handleChangeRole()" *ngIf="!isProduction || isTestMode"
            data-cy="account-role-item">
            <ion-icon name="person-outline"></ion-icon>
            <ion-label>Account Role</ion-label>
          </ion-item>
          <ion-item color="primary" (click)="handleSwitchAccount()" *ngIf="isVenueManager"
            data-cy="switch-account-item">
            <ion-icon name="person-outline"></ion-icon>
            <ion-label>Switch Account</ion-label>
          </ion-item>
          <ion-item color="primary" (click)="handleVenueManager()" *ngIf="isVenueManager && this.accountRole === 'resource'"
            data-cy="switch-account-item">
            <ion-icon name="person-outline"></ion-icon>
            <ion-label>Venue Manager</ion-label>
          </ion-item>
          <ion-item color="primary" (click)="handleVenue()" *ngIf="this.accountRole === 'venue-manager'"
            data-cy="switch-account-item">
            <ion-icon name="person-outline"></ion-icon>
            <ion-label>Resource</ion-label>
          </ion-item>
          <ion-item color="primary" (click)="handleLogout()" data-cy="logout-item">
            <ion-icon name="log-out-outline"></ion-icon>
            <ion-label>Log Out</ion-label>
          </ion-item>
        </ion-list>
      </div>
    </ion-content>
    <ion-footer>
      <ion-toolbar color="primary" class="version-container">
        <div class="ion-text-center" (click)="tapTestService.tap()">
          <ion-note>Version: {{ version }}</ion-note>
          <ion-note *ngIf="isTestMode">[testing]</ion-note>
        </div>
      </ion-toolbar>
    </ion-footer>
  </ion-menu>

  <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-app>